/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_DirectionInputs */

const cs_form_direction = /** @type {(inputs: Form_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Směr`)
};

const en_form_direction = /** @type {(inputs: Form_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction`)
};

/**
* | output |
* | --- |
* | "Direction" |
*
* @param {Form_DirectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_direction = /** @type {((inputs?: Form_DirectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_DirectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_direction(inputs)
	return cs_form_direction(inputs)
});